const state = {
  nav: [
    {
      label: "Setup Options",
      feature: "setup_options",
      route: "setup-options",
    },
    {
      label: "Outputs",
      feature: "outputs",
      route: "outputs",
    },
    {
      label: "Inputs",
      feature: "discrete_inputs",
      route: "inputs",
    },
    {
      label: "Asset Graph",
      feature: "outputs",
      route: "asset-graph",
    },
    {
      label: "Equipment & Infrastructure",
      feature: "edl_cil",
      subnav: [
        {
          label: "Equipment Dependencies",
          view: "edl",
          route: "edl_list",
          sidewayDisplay: "Equipment Dependency List"
        },
        {
          label: "Critical Infrastructure",
          view: "cil",
          route: "cil_list",
          sidewayDisplay: "Critical Infrastructure List"
        },
      ]
    },
    {
      label: "Wash Packages",
      feature: "wash_packages",
      subnav: [
        {
          label: "Washes",
          view: "washes",
          route: "wash-packages/washes",
          sidewayDisplay: "Washes"
        },
        {
          label: "Upsells",
          view: "upsells",
          route: "wash-packages/upsells",
        },
        {
          label: "Retracts",
          view: "overrides",
          route: "wash-packages/overrides",
        }
      ]
    },
    // {
    //   label: "Equipment",
    //   feature: "equipment",
    //   subnav: [
    //     {
    //       label: "Dry N' Shine",
    //       route: `equipment/7`,
    //       sidewayDisplay: "Dry N' Shine"
    //     },
    //     {
    //       label: "Crossover Wraps",
    //       route: `equipment/5`,
    //       sidewayDisplay: "Crossover Wraps"
    //     }
    //   ]
    // },
    {
      label: "Maintenance Mode",
      feature: "maintenance_mode",
      route: "maintenance-mode",
    },
    {
      label: "Request Logs",
      feature: "request_logs",
      route: "RequestLogs",
      sidewayDisplay: "Request Logs"
    },
    {
      label: "Assistance Tool",
      feature: "assistance_tool",
      subnav: [
        {
          label: "Additional Features",
          view: "control_word",
          route: "assistance_tool/control_word",
        },
        {
          label: "Omni Control",
          view: "omni_control",
          route: "assistance_tool/omni_control",
        },
        // {
        //   label: "Omni/Vacuum PID",
        //   view: "omni_vac",
        //   route: "assistance_tool/omni_vac",
        //   sidewayDisplay: "Omni/Vacuum PID"
        // },
        {
          label: "Blower Flip & Airgate",
          view: "airgate_tables",
          route: "assistance_tool/airgate_tables",
        },
        {
          label: "Mirror Bumps",
          view: "mirror_bumps",
          route: "assistance_tool/mirror_bumps",
        },
        {
          label: "Dry Run",
          view: "dry_run",
          route: "assistance_tool/dry_run",
        },
        {
          label: "Conveyor Speed",
          view: "conveyor_speed_selector",
          route: "assistance_tool/conveyor_speed_selector",
        },
        {
          label: "Blower Flips",
          view: "blower_flips",
          route: "assistance_tool/blower_flips",
        },
        {
          label: "PID Attack",
          view: "pid_attack_module",
          route: "assistance_tool/pid_attack_module",
        },
      ]
    },
    {
      label: "Internal Tools",
      feature: "internal_tools",
      internal: true,
      subnav: [
        {
          label: "Wash Map Config",
          view: "wash_map_config",
          route: "internal_tools/wash_map_config",
          internal: true
        },
        {
          label: "NOE Channels",
          view: "noe_channels",
          route: "internal_tools/noe_channels",
          internal: true
        },
        {
          label: "CCMMI",
          view: "ccmmi",
          route: "internal_tools/ccmmi",
          internal: true
        },
        {
          label: "Conveyor Drive",
          view: "conveyor_drive",
          route: "internal_tools/conveyor_drive",
          internal: true,
          c5: true
        },
      ],
    },
  ]
};
const getters = {
  siteCommandNav: state => state.nav
};

export default {
  state,
  getters
};